import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/product_groups/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import { validateForm } from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listProductGroups, updateProductGroup } from "../../../redux/actions/table/superadmin/product_groups";
import EditProductGroupForm from "../../../forms/superadmin/product_groups/EditProductGroupForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateProductGroup(formData.id, _.omit(formData, ['id'])).then(() => {
                listProductGroups();

                this.props.readAction(formData.id);

                setNotification("Properties have been saved.");
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditProductGroupForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'priority', 'product_category_id']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
